import React, { useEffect, useState } from "react";
import { Row, Col, Avatar, Typography, Button } from "antd";
import { BRANCH_STORAGE, USER_STORAGE } from "constants/index";
import { GetPropsHeader } from "./header-custom";
import { getById } from "services/user/user-service";
import { LogOut, Menu, UserRound } from "lucide-react";

const { Text } = Typography;
const font = "'Montserrat', sans-serif";

const LogoutButton = ({ onClick, size = 20 }) => (
  <Button
    type="text"
    icon={<LogOut size={size} />}
    onClick={onClick}
    aria-label="Sair"
    style={{ minWidth: 44, minHeight: 44 }}
  />
);

const Header = ({ logout, isMobile, onMenuToggle }) => {
  const [userName, setUserName] = useState("");
  const customHeader = GetPropsHeader(location.pathname);
  const [imgAvatar, setImgAvatar] = useState("");
  const [branchName, setBranchName] = useState(null);

  useEffect(() => {
    const localStorageItem = localStorage.getItem(USER_STORAGE);
    if (localStorageItem != null) {
      const { name, id } = JSON.parse(localStorageItem);
      setUserName(name);
      getById(id).then((res) => {
        setImgAvatar(res.img);
        setBranchName(res.branchName);
        localStorage.setItem(
          BRANCH_STORAGE,
          JSON.stringify({
            id: res.branchId,
            name: res.branchName,
            type: res.branchType,
            hasPhotocell: res.branchHasPhotoCell,
          })
        );
      });
    }
  }, []);

  useEffect(() => {
    const handleStorageChange = () => {
      const updatedType = getTypeBranch();
      setBranchName(updatedType);
    };

    window.addEventListener("storage", handleStorageChange);

    const interval = setInterval(() => {
      const currentType = getTypeBranch();
      setBranchName((prev) => (prev !== currentType ? currentType : prev));
    }, 1000);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
      clearInterval(interval);
    };
  }, []);

  function getTypeBranch() {
    const localStorageItemBranch = localStorage.getItem(BRANCH_STORAGE);
    if (localStorageItemBranch != null) {
      const branch = JSON.parse(localStorageItemBranch);
      return branch.name;
    }
    return branchName;
  }

  if (isMobile) {
    return (
      <div className="app-header-mobile">
        <Button
          type="text"
          icon={<Menu size={22} />}
          onClick={onMenuToggle}
          aria-label="Abrir menu"
          style={{ minWidth: 44, minHeight: 44 }}
        />
        <div style={{ flex: 1, minWidth: 0 }} className="header-title">
          {customHeader.pathIcon}
          <Text
            strong
            style={{ fontFamily: font, color: "#9FA1AA", marginLeft: 4 }}
          >
            {customHeader.pathName}
          </Text>
        </div>
        <Avatar src={imgAvatar} icon={<UserRound size={32} />} size={36} />
        <LogoutButton onClick={logout} />
      </div>
    );
  }

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        padding: "10px",
        background: "#E0E2E7",
      }}
    >
      <div style={{ flex: 1, marginLeft: "30px" }}>
        {customHeader.pathIcon}
        <Text strong style={{ fontFamily: font, color: "#9FA1AA" }}>
          {customHeader.pathName}
        </Text>
      </div>
      <div style={{ marginRight: "12px", textAlign: "end", minWidth: 0, maxWidth: "42%" }}>
        <Text
          strong
          ellipsis
          style={{ fontFamily: font, display: "block", maxWidth: "100%" }}
        >
          {userName}
        </Text>
        {branchName && (
          <Text
            ellipsis
            style={{
              fontFamily: font,
              fontSize: 10,
              display: "block",
              maxWidth: "100%",
            }}
          >
            {branchName}
          </Text>
        )}
      </div>
      <Row align="middle" gutter={4}>
        <Col>
          <Avatar src={imgAvatar} icon={<UserRound size={50} />} size={50} />
        </Col>
        <Col>
          <LogoutButton onClick={logout} />
        </Col>
      </Row>
    </div>
  );
};

export default Header;
